module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_5.6202f819.png";